// Routes that never get a music bed. The admin console is a work surface —
// a background loop autoplaying while an operator inspects campaigns or edits
// prompts is noise, not atmosphere.
//
// Lives outside MusicContext.jsx so the predicate can be imported by tests and
// by the route gate without adding another non-component export to the
// provider module (react-refresh/only-export-components).
export const isMusicDisabledPath = (pathname) => {
  if (typeof pathname !== 'string') return false;
  // react-router matches case-insensitively by default, so /Admin/prompts
  // renders the admin console just like /admin/prompts — match the router.
  const normalized = pathname.toLowerCase();
  return normalized === '/admin' || normalized.startsWith('/admin/');
};

export default isMusicDisabledPath;
